import { css } from '@eti/styles';
import { breakpoints } from '@etg/wings';
import { m as motion } from 'framer-motion';
// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { useEffect, useRef } from 'react';
import { getMealPreselectedTravelerChoices, sortTravelers } from '../utils/smallMealUtil';
import { getSellSpecification } from '../utils/mealUtil';
import { useMealCardSelection, useSmallMealPrice } from '../common/hooks';
import MealTravelerSelection from './MealTravelerSelection';
import { jsx as _jsx } from "react/jsx-runtime";
const wrapperStyles = css`
  grid-area: 5 / 1 / 6 / 3;
  overflow: hidden;

  @media (min-width: ${breakpoints._768}) {
    margin-inline-start: auto;
    width: 70%;
  }
`;
const SmallMealContent = ({
  cardSelection,
  mealPriceRaw,
  order,
  isMultipleTravelers,
  productName,
  smallMealTravelers,
  selectTraveler,
  selectProduct,
  selectAllTravelers,
  updateInitialValues,
  hasAnySelected,
  updateTotalPrice
}) => {
  const hasInitializedDefaultValues = useRef(false);
  const travelerInitialValues = getMealPreselectedTravelerChoices(order.travelers, getSellSpecification(order));
  useEffect(() => {
    if (!hasInitializedDefaultValues.current) {
      updateInitialValues(travelerInitialValues);
      hasInitializedDefaultValues.current = true;
    }
  }, [updateInitialValues, travelerInitialValues]);
  const sortedTravelers = isMultipleTravelers ? sortTravelers(smallMealTravelers) : smallMealTravelers;
  const sortedTravelersWithMeals = sortedTravelers.filter(traveler => traveler.mealPreferences.length > 0);
  useSmallMealPrice(updateTotalPrice, mealPriceRaw);
  const [isOpen] = useMealCardSelection(hasAnySelected, cardSelection, selectProduct, selectAllTravelers, sortedTravelersWithMeals);
  return /*#__PURE__*/_jsx(motion.div, {
    animate: {
      display: isOpen ? 'block' : 'none',
      height: isOpen ? 'auto' : 0,
      overflow: isOpen ? 'visible' : 'hidden'
    },
    className: wrapperStyles,
    "data-testid": "meal-content",
    initial: "false",
    onAnimationComplete: () => {
      selectAllTravelers(smallMealTravelers, cardSelection !== null && cardSelection !== void 0 ? cardSelection : false);
    },
    transition: {
      type: 'tween'
    },
    children: sortedTravelersWithMeals.map((traveler, index) => /*#__PURE__*/_jsx(MealTravelerSelection, {
      productName: productName,
      selectTraveler: selectTraveler,
      traveler: traveler
    }, index))
  });
};
export default SmallMealContent;
//# sourceMappingURL=SmallMealContent.js.map